import {LocationDescription} from '../_models/location-description.model';

// NGRX
import {createFeatureSelector, createSelector} from '@ngrx/store';
// CRUD
import {QueryResultsModel, HttpExtenstionsModel} from '../../_base/crud';
// State
import {LocationDescriptionsState} from '../_reducers/location-description.reducers';
import * as fromLocationDescription from '../_reducers/location-description.reducers';
import {each} from 'lodash';

export const selectLocationDescriptionsState = createFeatureSelector<LocationDescriptionsState>('locationDescriptions');

export const selectLocationDescriptionById = (locationDescriptionId: number) => createSelector(
    selectLocationDescriptionsState,
    locationDescriptionsState => locationDescriptionsState.entities[locationDescriptionId]
);

export const selectAllLocationDescriptions = createSelector(
    selectLocationDescriptionsState,
    fromLocationDescription.selectAll
);

export const selectAllLocationDescriptionsIds = createSelector(
    selectLocationDescriptionsState,
    fromLocationDescription.selectIds
);

export const allLocationDescriptionsLoaded = createSelector(
    selectLocationDescriptionsState,
    locationDescriptionsState => locationDescriptionsState.isAllLocationDescriptionsLoaded
);


export const selectLocationDescriptionsPageLoading = createSelector(
    selectLocationDescriptionsState,
    locationDescriptionsState => locationDescriptionsState.listLoading
);

export const selectLocationDescriptionsActionLoading = createSelector(
    selectLocationDescriptionsState,
    locationDescriptionsState => locationDescriptionsState.actionLoading
);

export const selectLastCreatedLocationDescriptionId = createSelector(
    selectLocationDescriptionsState,
    locationDescriptionsState => locationDescriptionsState.lastCreatedLocationDescriptionId
);

export const selectLocationDescriptionsShowInitWaitingMessage = createSelector(
    selectLocationDescriptionsState,
    locationDescriptionsState => locationDescriptionsState.showInitWaitingMessage
);

export const selectTrashedLocationDescriptionCount = createSelector(
    selectLocationDescriptionsState,
    (locationDescriptionsState) => locationDescriptionsState.totalTrashed
);

export const selectAdminTrashedLocationDescriptionCount = createSelector(
    selectLocationDescriptionsState,
    (locationDescriptionsState) => locationDescriptionsState.totalAdminTrashed
);


export const selectLocationDescriptionQueryResult = createSelector(
    selectLocationDescriptionsState,
    locationDescriptionsState => {
        const items: LocationDescription[] = [];
        each(locationDescriptionsState.entities, element => {
            items.push(element);
        });
        const httpExtension = new HttpExtenstionsModel();
        const result: LocationDescription[] = httpExtension.sortArray(items, locationDescriptionsState.lastQuery.sortField, locationDescriptionsState.lastQuery.sortOrder);

        return new QueryResultsModel(result, locationDescriptionsState.totalCount, '', locationDescriptionsState.totalTrashed);
    }
);
